module.exports = __webpack_public_path__ + "img/320px-Go.200a2b40.png";